// language=GraphQL
export const ALL_ACCOMMODATION_ADDONS_QUERY = `query Query($withCalculationSettings: Boolean = false, $withMandatorySettings: Boolean = false, $withMandatorySettingsRules: Boolean = false, $withMandatorySettingsRulesAccommodations: Boolean = false, $withMandatorySettingsRulesFamilyPackages: Boolean = false, $withMandatorySettingsRulesAccommodationAddons: Boolean = false, $withMandatorySettingsRulesAgeGroups: Boolean = false, $withMandatorySettingsRulesAgeFilter: Boolean = false, $withMandatorySettingsRulesTravelDates: Boolean = false, $withMandatorySettingsDateSwitchSettings: Boolean = false, $withMandatorySettingsBusSettings: Boolean = false) {
  accommodationAddons: ratioAccommodationAddons {
    id
    ratioServiceNo
    name
    label
    info
    calculationSettings @include(if: $withCalculationSettings) {
      id
      type
      considerHotelNights
    }
    mandatorySettings @include(if: $withMandatorySettings) {
      id
      isMandatory
      useRules
      rules @include(if: $withMandatorySettingsRules) {
        id
        checkAccommodationTypes
        accommodations @include(if: $withMandatorySettingsRulesAccommodations) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
        }
        familyPackages @include(if: $withMandatorySettingsRulesFamilyPackages) {
          id
          ratioServiceNo
          name
          label
          info
        }
        checkAccommodationAddons
        accommodationAddons @include(if: $withMandatorySettingsRulesAccommodationAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
        checkAgeGroups
        ageGroups @include(if: $withMandatorySettingsRulesAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
        useAgeFilter
        ageFilter @include(if: $withMandatorySettingsRulesAgeFilter) {
          id
          minAge
          maxAge
        }
        checkDateRange
        startDate
        endDate
        checkTravelDate
        travelDates @include(if: $withMandatorySettingsRulesTravelDates) {
          id
          dateNo
          startDate
          endDate
          isHidden
          includesExtension
          json
        }
      }
      useDateSwitch
      dateSwitchSettings @include(if: $withMandatorySettingsDateSwitchSettings) {
        id
        startDateOffsetDays
        endDateOffsetDays
      }
      useBusSettings
      busSettings @include(if: $withMandatorySettingsBusSettings) {
        id
        boardingSelectionEnabled
      }
    }
  }
}`

// language=GraphQL
export const SINGLE_ACCOMMODATION_ADDON_QUERY = `query Query($id: ID!, $withCalculationSettings: Boolean = false, $withMandatorySettings: Boolean = false, $withMandatorySettingsRules: Boolean = false, $withMandatorySettingsRulesAccommodations: Boolean = false, $withMandatorySettingsRulesFamilyPackages: Boolean = false, $withMandatorySettingsRulesAccommodationAddons: Boolean = false, $withMandatorySettingsRulesAgeGroups: Boolean = false, $withMandatorySettingsRulesAgeFilter: Boolean = false, $withMandatorySettingsRulesTravelDates: Boolean = false, $withMandatorySettingsDateSwitchSettings: Boolean = false, $withMandatorySettingsBusSettings: Boolean = false) {
  accommodationAddon: ratioAccommodationAddon(id: $id) {
    id
    ratioServiceNo
    name
    label
    info
    calculationSettings @include(if: $withCalculationSettings) {
      id
      type
      considerHotelNights
    }
    mandatorySettings @include(if: $withMandatorySettings) {
      id
      isMandatory
      useRules
      rules @include(if: $withMandatorySettingsRules) {
        id
        checkAccommodationTypes
        accommodations @include(if: $withMandatorySettingsRulesAccommodations) {
          id
          ratioPackageNo
          name
          label
          info
          isFamilyPackageAccommodation
          isBabyPackage
        }
        familyPackages @include(if: $withMandatorySettingsRulesFamilyPackages) {
          id
          ratioServiceNo
          name
          label
          info
        }
        checkAccommodationAddons
        accommodationAddons @include(if: $withMandatorySettingsRulesAccommodationAddons) {
          id
          ratioServiceNo
          name
          label
          info
        }
        checkAgeGroups
        ageGroups @include(if: $withMandatorySettingsRulesAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
        useAgeFilter
        ageFilter @include(if: $withMandatorySettingsRulesAgeFilter) {
          id
          minAge
          maxAge
        }
        checkDateRange
        startDate
        endDate
        checkTravelDate
        travelDates @include(if: $withMandatorySettingsRulesTravelDates) {
          id
          dateNo
          startDate
          endDate
          isHidden
          includesExtension
          json
        }
      }
      useDateSwitch
      dateSwitchSettings @include(if: $withMandatorySettingsDateSwitchSettings) {
        id
        startDateOffsetDays
        endDateOffsetDays
      }
      useBusSettings
      busSettings @include(if: $withMandatorySettingsBusSettings) {
        id
        boardingSelectionEnabled
      }
    }
  }
}`

// language=GraphQL
export const CREATE_ACCOMMODATION_ADDON_MUTATION = `
  mutation Mutation($input: CreateRatioAccommodationAddonInput, $withCalculationSettings: Boolean = false, $withMandatorySettings: Boolean = false, $withMandatorySettingsRules: Boolean = false, $withMandatorySettingsRulesAccommodations: Boolean = false, $withMandatorySettingsRulesFamilyPackages: Boolean = false, $withMandatorySettingsRulesAccommodationAddons: Boolean = false, $withMandatorySettingsRulesAgeGroups: Boolean = false, $withMandatorySettingsRulesAgeFilter: Boolean = false, $withMandatorySettingsRulesTravelDates: Boolean = false, $withMandatorySettingsDateSwitchSettings: Boolean = false, $withMandatorySettingsBusSettings: Boolean = false) {
    accommodationAddon: createRatioAccommodationAddon(input: $input) {
      id
      ratioServiceNo
      name
      label
      info
      calculationSettings @include(if: $withCalculationSettings) {
        id
        type
        considerHotelNights
      }
      mandatorySettings @include(if: $withMandatorySettings) {
        id
        isMandatory
        useRules
        rules @include(if: $withMandatorySettingsRules) {
          id
          checkAccommodationTypes
          accommodations @include(if: $withMandatorySettingsRulesAccommodations) {
            id
            ratioPackageNo
            name
            label
            info
            isFamilyPackageAccommodation
            isBabyPackage
          }
          familyPackages @include(if: $withMandatorySettingsRulesFamilyPackages) {
            id
            ratioServiceNo
            name
            label
            info
          }
          checkAccommodationAddons
          accommodationAddons @include(if: $withMandatorySettingsRulesAccommodationAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
          checkAgeGroups
          ageGroups @include(if: $withMandatorySettingsRulesAgeGroups) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
          useAgeFilter
          ageFilter @include(if: $withMandatorySettingsRulesAgeFilter) {
            id
            minAge
            maxAge
          }
          checkDateRange
          startDate
          endDate
          checkTravelDate
          travelDates @include(if: $withMandatorySettingsRulesTravelDates) {
            id
            dateNo
            startDate
            endDate
            isHidden
            includesExtension
            json
          }
        }
        useDateSwitch
        dateSwitchSettings @include(if: $withMandatorySettingsDateSwitchSettings) {
          id
          startDateOffsetDays
          endDateOffsetDays
        }
        useBusSettings
        busSettings @include(if: $withMandatorySettingsBusSettings) {
          id
          boardingSelectionEnabled
        }
      }
    }
  }`

// language=GraphQL
export const UPDATE_ACCOMMODATION_ADDON_MUTATION = `
  mutation Mutation($input: UpdateRatioAccommodationAddonInput, $withCalculationSettings: Boolean = false, $withMandatorySettings: Boolean = false, $withMandatorySettingsRules: Boolean = false, $withMandatorySettingsRulesAccommodations: Boolean = false, $withMandatorySettingsRulesFamilyPackages: Boolean = false, $withMandatorySettingsRulesAccommodationAddons: Boolean = false, $withMandatorySettingsRulesAgeGroups: Boolean = false, $withMandatorySettingsRulesAgeFilter: Boolean = false, $withMandatorySettingsRulesTravelDates: Boolean = false, $withMandatorySettingsDateSwitchSettings: Boolean = false, $withMandatorySettingsBusSettings: Boolean = false) {
    accommodationAddon: updateRatioAccommodationAddon(input: $input) {
      id
      ratioServiceNo
      name
      label
      info
      calculationSettings @include(if: $withCalculationSettings) {
        id
        type
        considerHotelNights
      }
      mandatorySettings @include(if: $withMandatorySettings) {
        id
        isMandatory
        useRules
        rules @include(if: $withMandatorySettingsRules) {
          id
          checkAccommodationTypes
          accommodations @include(if: $withMandatorySettingsRulesAccommodations) {
            id
            ratioPackageNo
            name
            label
            info
            isFamilyPackageAccommodation
            isBabyPackage
          }
          familyPackages @include(if: $withMandatorySettingsRulesFamilyPackages) {
            id
            ratioServiceNo
            name
            label
            info
          }
          checkAccommodationAddons
          accommodationAddons @include(if: $withMandatorySettingsRulesAccommodationAddons) {
            id
            ratioServiceNo
            name
            label
            info
          }
          checkAgeGroups
          ageGroups @include(if: $withMandatorySettingsRulesAgeGroups) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
          useAgeFilter
          ageFilter @include(if: $withMandatorySettingsRulesAgeFilter) {
            id
            minAge
            maxAge
          }
          checkDateRange
          startDate
          endDate
          checkTravelDate
          travelDates @include(if: $withMandatorySettingsRulesTravelDates) {
            id
            dateNo
            startDate
            endDate
            isHidden
            includesExtension
            json
          }
        }
        useDateSwitch
        dateSwitchSettings @include(if: $withMandatorySettingsDateSwitchSettings) {
          id
          startDateOffsetDays
          endDateOffsetDays
        }
        useBusSettings
        busSettings @include(if: $withMandatorySettingsBusSettings) {
          id
          boardingSelectionEnabled
        }
      }
    }
  }`

// language=GraphQL
export const DELETE_ACCOMMODATION_ADDON_MUTATION = `
  mutation Mutation($input: DeleteRatioAccommodationAddonInput) {
    deleteRatioAccommodationAddon(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_ACCOMMODATION_ADDON_MUTATION = `
  mutation Mutation($input: DeleteRatioAccommodationAddonInput) {
    forceDeleteRatioAccommodationAddon(input: $input) {
      success
    }
  }`
// language=GraphQL
export const ACCOMMODATION_ADDONS_DEPENDENTS_QUERY = `query Query($id: ID!, $withTravelPricingRules: Boolean = false, $withRatioTravels: Boolean = false, $withRatioAccommodations: Boolean = false, $withRatioFamilyPackages: Boolean = false, $withTravellers: Boolean = false) {
  groupedDependents: ratioAccommodationAddonDependents(id: $id) {
    travelPricingRules @include(if: $withTravelPricingRules) {
      id
      checkAccommodationTypes
      checkAccommodationAddons
      checkAgeGroups
      useAgeFilter
      checkDateRange
      startDate
      endDate
      checkTravelDate
    }
    ratioTravels @include(if: $withRatioTravels) {
      id
      catalogCode
      travelCode
      destination
      name
      transportType
      transportTypeLabel
      importDateTime
      importStatus
      suppressBusBoardingSelection    }
    ratioAccommodations @include(if: $withRatioAccommodations) {
      id
      ratioPackageNo
      name
      label
      info
      isFamilyPackageAccommodation
      isBabyPackage
    }
    ratioFamilyPackages @include(if: $withRatioFamilyPackages) {
      id
      ratioServiceNo
      name
      label
      info
    }
    travellers @include(if: $withTravellers) {
      id
      salutation
      firstName
      lastName
      birthday
      nationality
      email
      phone
      address
      addressNumber
      addressAddition
      zip
      city
      country
    }
  }
}`
